module.exports = __webpack_public_path__ + "static/hero1-95e5fc289ab96d4ed0e1c7844198a288.jpeg";